import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { CwtDirectiveView, getId, isset } from '@cawita/core-front';
import { Subscription } from 'rxjs';
import { ClientStore } from './client.store';
import { Client, ClientAccess } from '@shared/models';

export type ActiveClientContext = {
    $implicit: Client;
    access: ClientAccess;
    id: string;
}

@Directive({
    selector: '[cwtActiveClient]'
})
export class ActiveClientDirective {
    static ngTemplateContextGuard(dir: ActiveClientDirective, ctx: any): ctx is ActiveClientContext { return true; }

    private _sub: Subscription;
    private _ctx: ActiveClientContext = { $implicit: null, id: null, access: null };
    private _view = new CwtDirectiveView(this.vcRef, this.tRef, this._ctx);
    private _elseView = new CwtDirectiveView(this.vcRef, null);

    @Input('cwtActiveClientElse') public set elseRef(v: TemplateRef<any>) {
        this._elseView.setTemplate(v);
    }

    constructor(
        private tRef: TemplateRef<ActiveClientContext>,
        private vcRef: ViewContainerRef,
        private clientStore: ClientStore
    ) { }

    ngOnDestroy(): void {
        this._sub?.unsubscribe();
    }

    ngOnInit(): void {
        this._sub = this.clientStore.state$.subscribe({
            next: (state) => {
                this._ctx.$implicit = state.activeClient;
                this._ctx.id = getId(state.activeClient);
                this._ctx.access = state.activeAccess;
                this._view.ensureState(isset(state.activeClient));
                this._elseView.ensureState(!isset(state.activeClient));
            }
        });
    }
}
